export default [
  ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'ú', 'ü'],
  ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'ñ', 'á', 'ä', 'å'],
  ['z', 'x', 'c', 'v', 'b', 'n', 'm', 'é', 'í', 'ó', 'ç'],
]
